import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  success: false,
  errorMessage: null,
  saving: false
};

const DedicationSlice = createSlice({
  name: "Dedication",
  initialState,
  reducers: {
    dedicationSaving(state) {
      state.saving = true;
      state.errorMessage = null;
    },
    dedicationSuccess(state) {
      state.success = true;
      state.saving = false;
    },
    dedicationError(state, action) {
      state.errorMessage = action.payload;
      state.saving = false;
    },
    dedicationReset(state) {
      state.success = false;
      state.errorMessage = null;
      state.saving = false;
    }
  },
});

export const {
  dedicationSaving,
  dedicationSuccess,
  dedicationError,
  dedicationReset
} = DedicationSlice.actions

export default DedicationSlice.reducer;
